import { Icon } from '@billy/design-system'
import { ReactElement } from 'react'

import { InvoiceSentState } from '@features/invoicesLegacy/enums/invoiceSentState'

interface EmailStatusIconProps {
  sentState: InvoiceSentState
}

export const EmailStatusIcon = ({ sentState }: EmailStatusIconProps): ReactElement | null => {
  switch (sentState) {
    case InvoiceSentState.Opened:
    case InvoiceSentState.Printed:
    case InvoiceSentState.Viewed:
      return <Icon icon="mailCheck" />
    case InvoiceSentState.Sent:
      return <Icon icon="sendHorizontal" />
    default:
      return null
  }
}
